export const taxConstants = {
    TICKET_TAX_BREAKDOWN_REQUEST: 'TICKET_TAX_BREAKDOWN_REQUEST',
    TICKET_TAX_BREAKDOWN_SUCCESS: 'TICKET_TAX_BREAKDOWN_SUCCESS',
    TICKET_TAX_BREAKDOWN_FAILURE: 'TICKET_TAX_BREAKDOWN_FAILURE',

    TICKET_TAX_TERMS_QUERY_REQUEST: 'TICKET_TAX_TERMS_QUERY_REQUEST',
    TICKET_TAX_TERMS_QUERY_SUCCESS: 'TICKET_TAX_TERMS_QUERY_SUCCESS',
    TICKET_TAX_TERMS_QUERY_FAILURE: 'TICKET_TAX_TERMS_QUERY_FAILURE',

    TICKET_TAX_TERMS_ACCEPTED_REQUEST: 'TICKET_TAX_TERMS_ACCEPTED_REQUEST',
    TICKET_TAX_TERMS_ACCEPTED_SUCCESS: 'TICKET_TAX_TERMS_ACCEPTED_SUCCESS',
    TICKET_TAX_TERMS_ACCEPTED_FAILURE: 'TICKET_TAX_TERMS_ACCEPTED_FAILURE',
};

